document.addEventListener('DOMContentLoaded', () => {
  const form = document.getElementById('lottery-form');

  if (!form) return;

  const submitButton = document.getElementById('lottery-submit');
  const message = document.getElementById('lottery-message');

  const apparelCheckboxes = [
    ...form.querySelectorAll('[data-apparel-checkbox]')
  ];

  /*
   * アパレル商品のチェック状態に応じて、
   * それぞれのサイズ選択欄を表示・非表示にする
   */
  function updateApparelSizePanel(checkbox) {
    const productKey = checkbox.dataset.apparelCheckbox;

    const panel = form.querySelector(
      `[data-size-panel="${productKey}"]`
    );

    if (!panel) return;

    const sizeSelect = panel.querySelector('select');
    const isSelected = checkbox.checked;

    panel.hidden = !isSelected;

    if (sizeSelect) {
      sizeSelect.disabled = !isSelected;
      sizeSelect.required = isSelected;

      if (!isSelected) {
        sizeSelect.value = '';
      }
    }
  }

  /*
   * 初期状態の設定と、チェック変更時の処理
   */
  apparelCheckboxes.forEach((checkbox) => {
    updateApparelSizePanel(checkbox);

    checkbox.addEventListener('change', () => {
      updateApparelSizePanel(checkbox);
    });
  });

  /*
   * フォーム送信
   */
  form.addEventListener('submit', async (event) => {
    event.preventDefault();

    /*
     * スニーカーサイズは必須
     */
    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    /*
     * アパレルの選択商品を取得
     */
    const selectedApparel = apparelCheckboxes
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);

    /*
     * スニーカーは必ず応募商品に含める
     */
    data.application_products = [
      'YUTO HORIGOME × NIKE SB - AIR FORCE 1 "Iron Grey"',
      ...selectedApparel,
    ].join(' / ');

    /*
     * 商品ごとのサイズに空欄時の初期値を設定
     */
    data.sneaker_size = data.sneaker_size || '';
    data.thunder_blue_size = data.thunder_blue_size || '';
    data.summit_white_size = data.summit_white_size || '';
    data.tee_white_size = data.tee_white_size || '';
    data.tee_black_size = data.tee_black_size || '';

    /*
     * メルマガ登録チェックボックスは、
     * チェックなしでも false として送信する
     */
    data.accepts_marketing = formData.has('accepts_marketing')
      ? 'true'
      : 'false';

    /*
     * 同じコレクションへの重複応募を防止
     */
    const storageKey = `lottery_${data.collection_handle}`;

    if (localStorage.getItem(storageKey)) {
      message.textContent = 'すでにご応募いただいています。';
      message.style.color = 'red';
      return;
    }

    submitButton.disabled = true;

    const buttonText = submitButton.querySelector('.btn-text');

    if (buttonText) {
      buttonText.textContent = '送信中...';
    }

    /*
     * Google Apps Scriptへ送信
     */
    try {
      await fetch(
        'https://script.google.com/macros/s/AKfycbxgyiLe2P-As3k390_eyfryvYQkgF2lADxk5S9q2h76nEGKt7el053YMlPeYJ5nJx-TLA/exec',
        {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data),
        }
      );

      localStorage.setItem(storageKey, '1');

      form.innerHTML = `
        <div class="lottery-success">
          <p>
            ご応募ありがとうございます。<br>
            当選者様にはこちらからメールにてご連絡致します。
          </p>
        </div>
      `;
    } catch (error) {
      console.error('Lottery form submission error:', error);

      message.textContent =
        '送信に失敗しました。時間をおいて再度お試しください。';

      message.style.color = 'red';

      submitButton.disabled = false;

      if (buttonText) {
        buttonText.textContent = '応募する';
      }
    }
  });
});
